import { render, staticRenderFns } from "./SpecialistInformationWriter.vue?vue&type=template&id=d2a5831e"
import script from "./SpecialistInformationWriter.vue?vue&type=script&lang=js"
export * from "./SpecialistInformationWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports